<script>
    import jQuery from "jquery";
    import {GPCustomObject} from "./gp-customobject.js";
    import {selectedItemSet} from "./gp.js";
    import {selectedLabel} from "./gp-context-labels.js";
    import {GPPlant} from "./gp-plant";
    import {GPTypePlant} from "./gp-typeplant";
    import {fly} from "svelte/transition"
    import {getGPTransFunc} from "./gp-translations.js";
    import {GPContextItems, activePickerItem} from "./gp-context-items";
    let trans = getGPTransFunc("gp-iteminstancedetails");

    function open () {
        jQuery(document).off('GPItemRemoved', close).on('GPItemRemoved', close);
    }

    function close () {
        $selectedItemSet = []
    }

	function emit (action) {
        let evt = new CustomEvent(action, {});
        window.dispatchEvent(evt);
    }

</script>

{#if $selectedItemSet.length === 1}
<div id="itemInstanceDetails" transition:fly="{{ x: 200 }}">
    {#if $selectedItemSet[0] instanceof GPPlant}<div class="itemName">{$selectedItemSet[0].getName()}</div>{/if}
    <div class="itemInstanceActions">
        {#if $selectedItemSet[0].supportsInfo}
            <a on:click={() => emit("showItemDetails")} href="#" class="btn" role="button" title={trans('Item details')}><i class="fas fa-question-circle fa-lg"></i></a>
        {/if}
        {#if $selectedItemSet[0].supportsRotate}
            <a on:click={GP.rotateLeftItem} href="#" class="btn" role="button" title={trans('Rotate item left')}><i class="fas fa-undo fa-lg"></i></a>
            <a on:click={GP.rotateRightItem} href="#" class="btn" role="button" title={trans('Rotate item right')}><i class="fas fa-redo fa-lg"></i></a>
        {/if}
        <a on:click={GP.biggerSelectedItem} href="#" class="btn" role="button" title={trans('Enlarge item')}><i class="fas fa-plus-circle fa-lg"></i></a>
        <a on:click={GP.smallerSelectedItem} href="#" class="btn" role="button" title={trans('Shrink item')}><i class="fas fa-minus-circle fa-lg"></i></a>
        {#if $selectedItemSet[0].supportsFlip}
            <a on:click={GP.flipSelectedItem} href="#" class="btn" role="button" title={trans('Flip item')}><i class="fas fa-arrows-alt-h fa-lg"></i></a>
        {/if}
        {#if $selectedItemSet[0].supportsAdjust}
            <a on:click={() => emit("adjustSelectedItem")} href="#" class="btn" role="button" title={trans('Adjust item\'s color')}><i class="fas fa-adjust fa-lg"></i></a>
        {/if}
        <a on:click={GP.cloneSelectedItem} href="#" class="btn" role="button" title={trans('Clone item')}><i class="fas fa-clone fa-lg"></i></a>
        <a on:click={GP.removeSelectedItem} href="#" class="btn" role="button" title={trans('Delete item')}><i class="fas fa-trash-alt fa-lg"></i></a>
        <a on:click={()=>{selectedLabel.set($selectedItemSet[0])}} href="#" class="btn" role="button" title={trans('Add label')}><i class="fas fa-tag fa-lg"></i></a>
        {#if !($selectedItemSet[0] instanceof GPCustomObject && $selectedItemSet[0].temp)}
            <a on:click={()=>{GP.app.findItemInPicker($selectedItemSet[0])}} href="#" class="btn" role="button" title={trans('Find in catalog')}><i class="fas fa-bullseye fa-lg"></i></a>
        {/if}
        {#if $selectedItemSet[0] instanceof GPPlant && $activePickerItem instanceof GPTypePlant && $activePickerItem.id !== $selectedItemSet[0].typeId}
            <a on:click={GP.swapItems} href="#" class="btn" role="button" title={trans('Swap items')}><i class="fas fa-random fa-lg"></i></a>
        {/if}
    </div>
    <a on:click={close} href="#" class="btn itemCloseLink" role="button" title={trans('Close')}><i class="fa fa-times fa-sg"></i></a>
</div>
{/if}

{#if $selectedItemSet.length > 1}
<div id="itemInstanceDetails" transition:fly="{{ x: 200 }}">
    <div class="itemName">{trans("Multiple selection")}</div>
    <div class="itemInstanceActions">
        <a on:click={GP.biggerSelectedItem} href="#" class="btn" role="button" title={trans('Enlarge items')}><i class="fas fa-plus-circle fa-lg"></i></a>
        <a on:click={GP.smallerSelectedItem} href="#" class="btn" role="button" title={trans('Shrink items')}><i class="fas fa-minus-circle fa-lg"></i></a>
        <a on:click={GP.cloneSelectedItem} href="#" class="btn" role="button" title={trans('Clone items')}><i class="fas fa-clone fa-lg"></i></a>
        <a on:click={GP.cutSelectedItems} href="#" class="btn" role="button" title={trans('Cut items')}><i class="fas fa-cut fa-lg"></i></a>
        <a on:click={GP.copySelectedItems} href="#" class="btn" role="button" title={trans('Copy items')}><i class="fas fa-copy fa-lg"></i></a>
        <a on:click={GP.removeSelectedItem} href="#" class="btn" role="button" title={trans('Delete items')}><i class="fas fa-trash-alt fa-lg"></i></a>
        {#if $activePickerItem instanceof GPTypePlant && $selectedItemSet.filter(el => {return el instanceof GPPlant && el.typeId !== $activePickerItem.id}).length > 0}
            <a on:click={GP.swapItems} href="#" class="btn" role="button" title={trans('Swap items')}><i class="fas fa-random fa-lg"></i></a>
        {/if}
    </div>
    <a on:click={close} href="#" class="btn itemCloseLink" role="button"><i class="fa fa-times fa-sg"></i></a>
</div>
{/if}


